var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2853 0.611741L16.7803 5.10649C17.0464 5.37259 17.0708 5.78889 16.8534 6.08249L16.7809 6.16659L12.2858 10.6715C11.9933 10.9647 11.5184 10.9652 11.2252 10.6726C10.9586 10.4066 10.934 9.98999 11.1515 9.69619L11.224 9.61199L14.4409 6.38909L1.7451 6.38979C1.3654 6.38979 1.0516 6.10759 1.0019 5.74149L0.995098 5.63979C0.995098 5.26009 1.2772 4.94629 1.6433 4.89659L1.7451 4.88979L14.4429 4.88909L11.2246 1.67244C10.9584 1.40618 10.9341 0.989521 11.152 0.695901L11.2246 0.611781C11.4909 0.345501 11.9075 0.321281 12.2011 0.539131L12.2853 0.611741Z",
    fill: "#0086FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.1c0adcb231e9531f80f6259380a67828.svg";
export { ForwardRef as ReactComponent };